import React, { useEffect } from 'react';
import { Link, useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { usePosts } from '../hooks/usePosts';
import { PostDetail } from '../components/post/PostDetail';
import { postsApi } from '../api/posts';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../store';
import { removePost } from '../store/slices/postSlice';
import { useLanguage } from '../i18n/useLanguage';

export const PostPage: React.FC = () => {
  const { t } = useLanguage();
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { currentPost, loading, error, fetchPost } = usePosts();

  useEffect(() => {
    if (id) {
      const includeDeleted = searchParams.get('includeDeleted') === 'true';
      fetchPost(id, includeDeleted);
    }
  }, [id, fetchPost, searchParams]);

  const handleDelete = async () => {
    if (!id) return;

    try {
      await postsApi.deletePost(id);
      dispatch(removePost(id));
      navigate('/');
    } catch (error) {
      console.error('Failed to delete post:', error);
    }
  };

  const handleFlagged = () => {
    dispatch(removePost(id!));
    navigate('/');
  };

  return (
    <div className="post-page">
      <nav className="post-page-sticky-toolbar">
        <Link to="/" className="post-detail-back" aria-label={t('post.backToPostList')}>
          <svg
            className="post-detail-back-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          <span>{t('post.backToPostList')}</span>
        </Link>
      </nav>
      <PostDetail
        post={currentPost}
        loading={loading}
        error={error}
        onDelete={handleDelete}
        onFlagged={handleFlagged}
      />
    </div>
  );
};

